module.exports = __webpack_public_path__ + "img/icon-market-supplies.1120a136.png";